import type { AxiosRequestConfig } from 'axios'

export function buildSkipLanguageHeaderConfig(): AxiosRequestConfig {
  return { skipLanguageHeader: true }
}
